import { render, staticRenderFns } from "./InitialFeatures.vue?vue&type=template&id=bdabc3b2&scoped=true"
import script from "./InitialFeatures.vue?vue&type=script&lang=js"
export * from "./InitialFeatures.vue?vue&type=script&lang=js"
import style0 from "./InitialFeatures.vue?vue&type=style&index=0&id=bdabc3b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdabc3b2",
  null
  
)

export default component.exports